import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { IconButton, Menu, MenuItem, Box, FormControl, Select, TextField, Tooltip, ListSubheader,} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate, useParams } from "react-router-dom";
import { CiEdit, CiViewList } from "react-icons/ci";
import { MdViewQuilt } from "react-icons/md";
import { Modal, Offcanvas } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { IoIosArrowBack } from "react-icons/io";
import SearchBar from "../../SearchBar";
import { CiCirclePlus, CiFilter } from "react-icons/ci";
import { PiBagFill } from "react-icons/pi";
import { newFilterEntities, postResource,} from "../../../apis/apiService";
import { toast } from "react-toastify";
import Loader, { BtnLoader } from "../../common/Loader";
import { useSelector } from "react-redux";
import { CustomNoRowsOverlay } from "../../common/OverlayGrid";
import dayjs from "dayjs";
import CommonDeleteDialog from "../../common/CommonDelete";
import { CommonAddTaskTab } from "../../common/Task/CommonAddTaskTab";
import Movetask from "../../common/Task/Movetask";
import { hasTaskPermission } from "../../../utils/Permissions";
import { TaskFilterComponent } from "../task/TaskTab";
import { FilterSummaryBox } from "../../common/FilterSummaryBox";
import { MilestoneTaskExport } from "./MilestoneTaskExport";
import { MilestoneTaskBoardFilter } from "../task/milestonetaskboardfilter";
import SubtaskBoard from "../task/SubtaskBoard";
import { useTheme } from "../../../ThemeContext";



function MilestoneSubTasklist() {
  const { isDarkMode } = useTheme();
  const { task_list_id, project_id, } = useParams();

  if (task_list_id) {
    localStorage.setItem("task_list_id", task_list_id);
  }

  const { reset } = useForm();
  const [task, setTask] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedSubtask, setSelectedSubtask] = useState(null);
  const [filter, setFilter] = useState(1);
  // const [projects, setProjects] = useState(tasksData);
  const [showExportPage, setShowExportPage] = useState(false);
  const [MilestoneTask, setMilestoneTask] = useState([]);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [tableSearchTerm, setTableSearchTerm] = useState("");
  const [boardSearchTerm, setBoardSearchTerm] = useState("");
  const [showFilter, setShowFilter] = useState(false);
  const [showProject, setShowProject] = useState(false);
  const [headanchorEl, setheadAnchorEl] = useState(null);
  const [tasksListName, setTasksListName] = useState("");
  const [projectName, setProjectName] = useState("");
  const loginUser = useSelector((state) => state.selectOptions?.loginUserName);
  ////console.log()("login_user_detail in redux state: ", loginUser);
  const { id: login_user_id, role: login_user_role } = loginUser;
  const [loading, setLoading] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const navigate = useNavigate();
  const [showEditModal, setShowEditModal] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [filterValue, setFilterValue] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const [viewMode, setViewMode] = useState(() => {
    return (
      sessionStorage.getItem(`milestone_task_view_mode_${task_list_id}`) ||
      "list"
    );
  });

  useEffect(() => {
    if (task_list_id) {
      sessionStorage.setItem(`milestone_task_view_mode_${task_list_id}`, viewMode);
    }
  }, [viewMode, task_list_id]);

  const fetchSearchedMilestoneTask = async (searchQuery) => {
    // setLoading(true);
    try {
      const response = await newFilterEntities( "milestones/task", task_list_id,
        {
          // search: searchQuery,
          search: searchQuery.trim(),
          view_type_id: filter,
        },
      );
      if (response.status) {
        const mappedData = response.data.map(item => ({
          ...item,
          id: item.id || item.task_id
        }));
        setMilestoneTask(mappedData);
      } 
      else {
        setMilestoneTask([]);
      }
    } 
    catch (error) {
      console.error("Failed to fetch Milestone:", error);
      setMilestoneTask([]);
      // Handle the error appropriately in the caller
    // } finally {
    //   setLoading(false);
    }
  };

  const {
    handleSubmit: handleEditSubmit,
    reset: editReset,
    control: editControl,
    formState: { errors: editErrors },
  } = useForm();

  useEffect(() => {
    if (selectedTask && showEditModal) {
      editReset({
        task_name: selectedTask?.title || "",
      });
    }
    console.log("selectedTask :", selectedTask);
  }, [selectedTask, showEditModal]);

  const onEditSubmit = async (data) => {
    setEditLoading(true);
    const requestData = {
      title: data.task_name,
    };
    try {
      await postResource( "task", "update", selectedTask.task_id, requestData );
      // toast.success(response.message);
      setShowEditModal(false);
      // fetchSearchedMilestoneTask();
       fetchMilestoneTask();
    } 
    catch (error) {
      toast.error(error.message || error.response?.data?.message);
    } 
    finally {
      setEditLoading(false);
    }
  };

  const handleExportPage = () => {
    setShowExportPage(true);
  };

  const onCancel = () => {
    setShowExportPage(false);
  };

  const fetchMilestoneTask = async () => {
    setLoading(true);
    const requestedData = {
      view_type_id: filter,
    };
    try {
      const response = await newFilterEntities( "milestones/task", task_list_id, requestedData,);
      // setFilterValue(false); // Removed to prevent it from resetting when switching tabs
      ////console.log()(response, "fetchMilestoneTask");
      if (response) {
        const {
          tasks_list_name,
          project_name,
          task_close_count,
          task_open_count,
        } = response;

        // Set tasks list and project name
        setTasksListName({
          tasks_list_name,
          project_name,
          task_open_count,
          task_close_count,
        });
        setProjectName(project_name);

        if (response?.data) {
          const data = response.data.map(item => ({
            ...item,
            id: item.id || item.task_id
          }));
          // const data = response.issues.map((issue) => ({
          //   ...issue,
          //   id: issue.issue_id, // Add id field for Data Grid
          // }));
          ////console.log()(data, "Mapped Issues Data");
          setMilestoneTask(data);
        } 
        else {
          console.error("No issues found in the response.");
        }
      } 
      else {
        console.error("API call failed");
      }
    } 
    catch (error) {
      console.error("Error fetching issues:", error);
    } 
    finally {
      setLoading(false);
    }
  };
  
  useEffect(() => {
    fetchMilestoneTask();
  }, [filter]);

  // useEffect(() => {
  //   setTask(tasksData[taskId]);
  // }, [taskId]);

  const filterOptions = {
    predefined: [
      { label: "All Tasks", value: 1 },
      { label: "All Open", value: 2 },
      { label: "All Closed", value: 3 },
      { label: "All Overdue & Open", value: 4 },
      { label: "Unassigned", value: 5 },
      // { label: "Unscheduled Tasks", value: "unscheduled" },
      // { label: "Closed Task Lists", value: "closed_task_lists" },
    ],
    myViews: [
      { label: "My Open", value: 6 },
      { label: "My Closed", value: 7 },
      // { label: "My Overdue & Open", value: 7 },
      { label: "Today's Tasks", value: 8 },
      { label: "Tasks I Follow", value: 9 },
      { label: "Tasks Created By Me", value: 10 },
      // { label: "Assigned Via Pick List", value: "assigned_via_pick_list" },
    ],
  };

  const handleFilterChange = (event) => {
    const value = event.target.value;
    setFilter(value);

    let filteredProjects;
    switch (value) {
      case "completed":
        filteredProjects = MilestoneTask.filter(
          (project) => project.completion === 100,
        );
        break;
      case "recent":
        filteredProjects = MilestoneTask; // Modify this to sort/filter based on recent access logic
        break;
      default:
        filteredProjects = MilestoneTask;
    }

    setMilestoneTask(filteredProjects);
  };

  const handleSearchChange = async (event) => {
    const value = event.target.value;
    if (viewMode === "list") {
      setTableSearchTerm(value);
      if (value) {
        await fetchSearchedMilestoneTask(value);
      } 
      else {
        await fetchMilestoneTask();
      }
    } else {
      setBoardSearchTerm(value);
      if (value) {
        await fetchSearchedMilestoneTask(value);
      } 
      else {
        await fetchMilestoneTask();
      }
    }
  };

  const handleShowFilter = () => setShowFilter(true); // Open filter
  const handleShowProject = () => setShowProject(true); // Open filter

  const handleActionClick = (event, subtask) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedSubtask(subtask);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClone = () => {
    ////console.log()(`Clone task: ${selectedSubtask}`);
    handleClose();
  };

  const handleView = () => {
    // //console.log(`View_task: ${selectedSubtask}`);
    const path = `/projects/projectDetail/${project_id}/milestone/MilestoneDetail/${selectedTask?.milestone_id}/MilestoneSubTasklist/${selectedTask?.task_list_id}/TasklistDetail/${selectedTask?.task_id}`;
    navigate(path);
    handleClose();
  };
  const handleViewDitailstab = () => {
    ////console.log()(`View task on new tab: ${selectedTask}`);
    const path = `/projects/projectDetail/${project_id}/milestone/MilestoneDetail/${selectedTask?.milestone_id}/MilestoneSubTasklist/${selectedTask?.task_list_id}/TasklistDetail/${selectedTask?.task_id}`;
    navigate(path, "_blank");
    handleClose();
  };
  const handleCopylink = () => {
    ////console.log()(`Copy task: ${selectedSubtask}`);
    handleClose();
  };
  // const handleFilterApply = (filteredData) => {
  //   setMilestoneTask(
  //     filteredData.map((project) => ({
  //       ...project,
  //       id: project.task_id, // Ensure `id` is correctly set for DataGrid
  //     }))
  //   );

  //   setShowFilter(false); // Close the filter modal
  // };
  const handleFilterApply = (filteredData) => {
    ////console.log()("Applying filter", filteredData);
    const mappedData = filteredData.map(item => ({
      ...item,
      id: item.id || item.task_id
    }));
    setMilestoneTask(mappedData);
    setShowFilter(false); // Close the modal
    setFilterValue(true);
  };

  // if (!task) return <Typography>Loading...</Typography>;

  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 120,
      renderCell: (params) => {
        //console.log("params_value in render :".params);

        return (
          <Box display="flex" alignItems="center">
            {/* More options button */}
            <IconButton
              onClick={(event) => {
                event.stopPropagation(); // Prevent row click event
                handleMenuOpen(event, params.row); // Example menu functionality
              }}
            >
              <MoreVertIcon />
            </IconButton>
          </Box>
        );
      },
    },
    { field: "task_id", 
      headerName: "ID", 
      width: 150 
    },
    { field: "title", 
      headerName: "Task", 
      flex: 1, 
      minWidth: 150 
    },
    {
      field: "owner_name",
      headerName: "Owner",
      width: 150,
      renderCell: (params) => {
        const owners = params.row.owners || [];
        if (owners.length === 0) return "Unassigned";
        const displayValue = `${owners[0].name}${owners.length > 1 ? ` (+${owners.length - 1})` : ""}`;

        const tooltipTitle = (
          <Box>
            {owners.map((o, index) => (
              <div key={index}>{o.name}</div>
            ))}
          </Box>
        );

        return (
          <Tooltip title={tooltipTitle} arrow>
            <Box sx={{ cursor: "pointer" }}>{displayValue}</Box>
            </Tooltip>
        );
      },
    },
    {
      field: "current_status_name",
      headerName: "Status",
      width: 150,
      renderCell: (params) => {
        const color = params.row.status_colour;
        return (
          <Box>
            <label style={{ color: color || "black" }}>
              {params.row.current_status_name}
            </label>
          </Box>
        );
      },
    },
    {
      field: "start_date",
      headerName: "Start Date",
      width: 150,
      renderCell: (params) =>
        // new Date(params.row.start_date).toLocaleDateString(),
        params.row.start_date
          ? dayjs(params.row.start_date).format("DD-MM-YYYY")
          : "",
      // dayjs(params.row.end_date).format("DD-MM-YYYY"),
    },
    {
      field: "end_date",
      headerName: "Due Date",
      width: 150,
      renderCell: (params) =>
        // new Date(params.row.end_date).toLocaleDateString(),
        // dayjs(params.row.end_date).format("DD-MM-YYYY"),
        params.row.end_date
          ? dayjs(params.row.end_date).format("DD-MM-YYYY")
          : "",
    },
    { field: "estimated_hours", 
      headerName: "Estimated hours", 
      width: 150 
    },
    {
      field: "priority_name",
      headerName: "Priority",
      width: 150,
      renderCell: (params) => {
        const color = params.row.priority_colour;
        return (
          <Box>
            <label style={{ color: color || "black" }}>
              {params.row.priority_name}
            </label>
          </Box>
        );
      },
    },
    { 
      field: "completed_percentage", 
      headerName: "Completed %", 
      width: 150 
    },
    {
      field: "billing_type",
      headerName: "Billable Type",
      width: 150,
      renderCell: (params) => params.row.billing_type || "-",
    },
    { field: "creater_name", 
      headerName: "Created By", 
      width: 150 
    },
    {
      field: "added_at",
      headerName: "Created At",
      width: 180,
      renderCell: (params) =>
        params.row.added_at
          ? dayjs(params.row.added_at).format("DD-MM-YYYY hh:mm A")
          : "-",
    },
    {
      field: "updated_name",
      headerName: "Updated By",
      width: 200,
      renderCell: (params) => params.row.updated_name || "N/A",
    },
    {
      field: "updated_at",
      headerName: "Updated At",
      width: 180,
      renderCell: (params) =>
        params.row.updated_at
          ? dayjs(params.row.updated_at).format("DD-MM-YYYY hh:mm A")
          : "-",
    },

    // { field: "consumed_hours", headerName: "Work Hours", width: 150 },
    // { field: "timelog", headerName: "Time log", width: 150 },
    // { field: "billing_type", headerName: "Billable Type", width: 150 },
  ];

  const handleClick = (event) => {
    setheadAnchorEl(event.currentTarget);
  };

  const handleMenuOpen = (event, row) => {
    //console.log("params_value :", row);

    setMenuAnchorEl(event.currentTarget);
    setSelectedTask(row);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    // setSelectedTask(null);
  };
  const HeadhandleClose = () => {
    setheadAnchorEl(null); // Ensure this sets the anchor element to null to close the menu
  };
  const handleBackClick = () => {
    navigate(-1); // Navigates to the previous page
  };

  const handleRowClick = (params) => {
    const { task_id } = params.row;
    //console.log("params_value_in_stone :", params);

    navigate(
      `/projects/projectDetail/${project_id}/milestone/MilestoneDetail/${params.row.milestone_id}/MilestoneSubTasklist/${params.row.task_list_id}/TasklistDetail/${task_id}`,
    );
  };
  useEffect(() => {
    sessionStorage.setItem("isTaskFilterApplied", false);
    sessionStorage.removeItem("task_filter_data");
  }, []);

  const handleClearFilter = () => {
    fetchMilestoneTask();
    sessionStorage.setItem("isTaskFilterApplied", false);
    sessionStorage.removeItem("task_filter_data");
    setFilterValue(false);
  };

  ////console.log()("MilestoneTask :", MilestoneTask, selectedTask);
  const canEditTask = hasTaskPermission(
    selectedTask,
    login_user_id,
    login_user_role,
  );

  const handleClearBoardFilter = () => {
    fetchMilestoneTask();
    sessionStorage.setItem("isMilestoneBoardFilterApplied", false);
    sessionStorage.removeItem("milestone_board_filter_data");
    setFilterValue(false);
  };

  useEffect(() => {
    const isTaskApplied = sessionStorage.getItem("isTaskFilterApplied") === "true";
    const isBoardApplied = sessionStorage.getItem("isMilestoneBoardFilterApplied") === "true";

    if (viewMode === "list") {
      setFilterValue(isTaskApplied);
    } 
    else {
      setFilterValue(isBoardApplied);
    }
  }, [viewMode, MilestoneTask]); // Update when tab changes or data is refetched

  return (
    <>
      <Offcanvas
        show={showProject}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          {/* <AddSubMilestoneTaskComponent
            // onApply={handleApplyFilter}
            // onClear={handleClearFilter}
            // onCancel={() => setShowFilter(false)}
            onApply={(filters) =>
              setMilestoneTask()
            }
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
            fetchMilestoneTask={fetchMilestoneTask}
          /> */}
          <CommonAddTaskTab
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
            refetchList={fetchMilestoneTask}
            path_1="milestones/task"
            path_2="add"
            isSubtaskList={true}
            isMilestone={true}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      <Offcanvas
        show={showExportPage}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          <MilestoneTaskExport onCancel={onCancel} />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>
      {/* Add filter */}
      <Offcanvas
        show={showFilter}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          {showFilter && (viewMode === "board" ? (
            <MilestoneTaskBoardFilter
              isMilestoneTask={true}
              milestone_id={task_list_id}
              filterid={filter}
              onApply={handleFilterApply}
              filter_path="milestones/task"
              onClear={handleClearBoardFilter}
              onCancel={() => setShowFilter(false)}
            />
          ) : (
            <TaskFilterComponent
              // onApply={handleApplyFilter}
              // onClear={handleClearFilter}
              // onCancel={() => setShowFilter(false)}
              // onApply={handleFilterApply}
              // onClear={() => reset()} // Resets to initial values
              // onCancel={() => setShowFilter(false)}
              isMilestoneTask={true}
              milestone_id={task_list_id}
              filterid={filter}
              onApply={handleFilterApply}
              filter_path="milestones/task"
              // onClear={() => reset()} // Reset filter
              // onCancel={() => setShowFilter(false)}
              onCancel={() => setShowFilter(false)}
              onClear={handleClearFilter}
            />
          ))}
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>

      <div className="d-flex justify-content-between align-items-center bg-white mb-3  p-3 border-bottom rounded-bottom">
        <div>
          <div className="d-flex align-items-center gap-3">
            <button 
            className="R_btn me-2" 
            onClick={handleBackClick} 
            style={{ cursor: "pointer" }}>
              <IoIosArrowBack size={18} className="text-rgba-gray" />
            </button>

            <label className="text-rgba-gray m-0 d-flex align-items-center gap-1" 
            style={{ color: isDarkMode ? "#a0aec0" : undefined }}>
              <PiBagFill 
              className="text-rgba-gray me-1" 
              style={{ color: isDarkMode ? "#a0aec0" : undefined }} />
              Project Name: 
              <span 
              className={`fw-semibold ms-1 ${isDarkMode ? "text-white" : "text-dark"}`}>
                {projectName || tasksListName.project_name}
              </span>
            </label>

            <span 
            className="text-rgba-gray border-start ps-3 py-1" 
            style={{ color: isDarkMode ? "#a0aec0" : undefined }}>
              Task List Name: 
              <span 
              className={`fw-semibold ms-1 ${isDarkMode ? "text-white" : "text-dark"}`}>
                {tasksListName.tasks_list_name}
              </span>
            </span>
          </div>
        </div>

        <div className="d-flex align-items-center">
          <div>
            {/* <span>{tasksListName.task_open_count}</span> */}
            {/* <span>{tasksListName.task_open_count}</span> */}
            <span>
              {MilestoneTask.filter(t => (t.current_status_name || t.status_name || "").toUpperCase() === "OPEN").length}
            </span>
            <lable className="text-rgba-gray"> Open</lable>
          </div>

          <div className="ps-3">
            {/* <span>{tasksListName.task_close_count}</span> */}
            <span>
              {MilestoneTask.filter(t => (t.current_status_name || t.status_name || "").toUpperCase().includes("CLOSED")).length}
            </span>
            <lable className="text-rgba-gray"> Closed</lable>
          </div>
          {/* <div className="ps-3">
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
             
              <BsThreeDots />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={headanchorEl}
              open={Boolean(headanchorEl)}
              onClose={HeadhandleClose}
              PaperProps={{
                style: {
                  maxHeight: 48 * 4.5,
                  width: "20ch",
                },
              }}
            >
              <MenuItem>Edit</MenuItem>
              <MenuItem>Delete</MenuItem>
              <MenuItem>Clone</MenuItem>
              <MenuItem>Copy Link</MenuItem>
            </Menu>
          </div> */}
        </div>
      </div>

      <div className="bg-white p-3">
        <Box
          className="d-flex flex-wrap justify-content-between align-items-center gap-3"
          sx={{
            border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
            borderRadius: "6px",
            padding: "12px 16px",
            marginBottom: "12px",
            backgroundColor: isDarkMode ? "transparent" : "#fff",
          }}
        >
          <div className="d-flex flex-wrap gap-3 align-items-center">
            <FormControl sx={{ width: "auto", minWidth: "105px" }} size="small">
              <Select value={filter} onChange={handleFilterChange} displayEmpty size="small" autoWidth>
                <ListSubheader className="ps-3 text-rgba-gray">Predefined Views</ListSubheader>
                {filterOptions.predefined.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
                <ListSubheader className="ps-3 text-rgba-gray">My Views</ListSubheader>
                {filterOptions.myViews.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <div className="d-flex align-items-center" style={{ gap: "6px", alignSelf: "center" }}>
              <Tooltip title="Table View">
                <IconButton
                  onClick={async () => {
                    setViewMode("list");
                    if (tableSearchTerm) {
                      await fetchSearchedMilestoneTask(tableSearchTerm);
                    } 
                    else {
                      await fetchMilestoneTask();
                    }
                  }}
                  sx={{
                    backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                    color: viewMode === "list" ? "rgba(18, 183, 159, 1)" : "#626161",
                    border: viewMode === "list" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                    borderRadius: "4px",
                    height: "34px",
                    width: "75px",
                    gap: "4px",
                    fontSize: "13px",
                    fontWeight: 500,
                    marginRight: "8px",
                    "&:hover": {
                      backgroundColor: viewMode === "list" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  <CiViewList size={18} />
                  Table
                </IconButton>
              </Tooltip>

              <Tooltip title="Board View">
                <IconButton
                  onClick={async () => {
                    setViewMode("board");
                    if (boardSearchTerm) {
                      await fetchSearchedMilestoneTask(boardSearchTerm);
                    }
                    else {
                      await fetchMilestoneTask();
                    }
                  }}
                  sx={{
                    backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.1)" : "transparent",
                    color: viewMode === "board" ? "rgba(18, 183, 159, 1)" : "#626161",
                    border: viewMode === "board" ? "1.5px solid rgba(18, 183, 159, 0.6)" : "1.5px solid #d0d0d0",
                    borderRadius: "4px",
                    height: "34px",
                    width: "75px",
                    gap: "4px",
                    fontSize: "13px",
                    fontWeight: 500,
                    "&:hover": {
                      backgroundColor: viewMode === "board" ? "rgba(18, 183, 159, 0.2)" : "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                >
                  <MdViewQuilt size={18} />
                  Board
                </IconButton>
              </Tooltip>
            </div>
          </div>

          <div
            className="d-flex flex-wrap justify-content-md-end gap-2 align-items-center">
            <SearchBar
              placeholder="Search Tasks"
              searchTerm={viewMode === "list" ? tableSearchTerm : boardSearchTerm}
              onSearchChange={handleSearchChange}
            />
            {filterValue && (
              <button
                className=" addmore_btn"
                disabled={loading}
                // onClick={handleClearFilter}
                onClick={viewMode === "board" ? handleClearBoardFilter : handleClearFilter}
              >
                Clear filter
              </button>
            )}

            {login_user_role !== "CLIENT" && (
              <Tooltip title="Add Task">
                <IconButton
                  onClick={handleShowProject}
                  sx={{
                    backgroundColor: isDarkMode ? "rgba(67, 105, 255, 0.08)" : "#F1F5FF",
                    borderRadius: "50%",
                    width: "39px",
                    height: "39px",
                    marginLeft:"8px",
                    color: "rgba(18, 183, 159, 1)",
                    "&:hover": { backgroundColor: "var(--icon-hover-bg)" },
                  }}
                >
                  <CiCirclePlus className="pro-icon-s" />
                </IconButton>
              </Tooltip>
            )}

            <Tooltip title="Filter">
              <IconButton
                onClick={handleShowFilter}
                sx={{
                  backgroundColor: isDarkMode ? "rgba(67, 105, 255, 0.08)" : "#F1F5FF",
                  borderRadius: "50%",
                  width: "39px",
                  height: "39px",
                  marginLeft:"8px",
                  color: "rgba(18, 183, 159, 1)",
                  "&:hover": { backgroundColor: "var(--icon-hover-bg)" },
                }}
              >
                <CiFilter className="pro-icon-s" />
              </IconButton>
            </Tooltip>
          </div>
        </Box>
        {loading ? (
          <Loader /> // Display loader while loading
        ) : (
          <div className="row">
            {viewMode === "list" && (
              <div className="col-12 ">
                <FilterSummaryBox
                  onApply={handleFilterApply}
                  status_type="TASK"
                  task_filter_id={task_list_id}
                  has_view_type={true}
                  // filter_path="/project/filter"
                  filter_path="milestones/task"
                />
              </div>
            )}

            {viewMode === "board" ? (
              <div className="col-12 mt-3">
                <SubtaskBoard
                  numericId={task_list_id}
                  allTasks={MilestoneTask}
                  onRefresh={fetchMilestoneTask}
                  loading={loading}
                  onOpenTask={(t) => handleRowClick({ row: t })}
                />
              </div>
            ) : (
              <div className="col-12">
                <Box sx={{ height: MilestoneTask.length === 0 ? 300 : "100%" }}>
                  <DataGrid
                    rows={MilestoneTask}
                    columns={columns}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                    pageSizeOptions={[10, 20, 30, 40, 50]}
                    onRowClick={handleRowClick}
                    getRowId={(row) => row.id || row.task_id}
                  />

                  <Menu
                    anchorEl={menuAnchorEl}
                    open={Boolean(menuAnchorEl)}
                    onClose={handleMenuClose}
                  >
                    <MenuItem onClick={handleView}>
                      <CiViewList className="me-2" color="blue" />
                      View Details
                    </MenuItem>
                    <MenuItem onClick={handleViewDitailstab}>
                      <CiViewList className="me-2" color="blue" />
                      View Details in New Tab
                    </MenuItem>
                    {/* {selectedTask &&
                    (["ADMIN", "MANAGER"].includes(login_user_role) ||
                      MilestoneTask.find(
                        (milestone) => milestone.task_id === selectedTask?.task_id
                      )?.added_by === login_user_id) && (
                      // <MenuItem onClick={handleDeleteTask}>
                      //   <DeleteForever className="me-2" color="error" />
                      //   Delete
                      // </MenuItem>
                      <CommonDeleteDialog
                        name="Task"
                        statusName={
                          MilestoneTask.find(
                            (list) => list.task_id === selectedTask?.task_id
                          )?.title
                        }
                        url="task/delete"
                        id={selectedTask?.task_id}
                        refetchList={fetchMilestoneTask}
                        handleListClose={handleMenuClose}
                      />
                    )} */}
                    {canEditTask && (
                      <>
                        <CommonDeleteDialog
                          name="Task"
                          refetchList={fetchMilestoneTask}
                          handleListClose={handleMenuClose}
                          url="task/delete"
                          id={selectedTask?.id}
                          statusName={selectedTask?.title}
                          logHours={selectedTask?.timelogs}
                        // statusName={rows.find((task)=>task.task_id === selectedTask)?}
                        />

                        <Movetask
                          handleMenuClose={handleMenuClose}
                          login_user_id={login_user_id}
                          selectedTask={selectedTask}
                          path="task/moveTask"
                          project_id={project_id}
                          refetch_list={fetchMilestoneTask}
                        />

                        <MenuItem
                          onClick={() => {
                            setShowEditModal(true);
                            handleMenuClose();
                          }}
                        >
                          <CiEdit className="me-2" color="blue" />
                          Edit Task
                        </MenuItem>
                      </>
                    )}
                  </Menu>
                </Box>
              </div>
            )}
          </div>
        )}
      </div>

      <Modal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Task</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form id="edit-task-form" onSubmit={handleEditSubmit(onEditSubmit)}>
            <div className="mb-3">
              <label htmlFor="task_name" className="form-label">
                Task Name <span className="errorMsg">*</span>
              </label>
              <Controller
                name="task_name"
                defaultValue={selectedTask?.title || ""}
                control={editControl}
                render={({ field }) => (
                  <TextField
                    {...field}
                    type="text"
                    placeholder="Enter task name"
                    className="form-control"
                  />
                )}
              />
              {editErrors.task_name && (
                <span className="text-danger">
                  {editErrors.task_name.message}
                </span>
              )}
            </div>
          </form>
        </Modal.Body>
        
        <Modal.Footer>
          <button
            type="button"
            className="cancel_btn"
            onClick={() => setShowEditModal(false)}
          >
            Cancel
          </button>
          <button
            type="submit"
            form="edit-task-form"
            className="add_btn"
            disabled={editLoading}
          >
            {editLoading ? <BtnLoader /> : "Update"}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default MilestoneSubTasklist;
